import { creating, exist, Id } from '@campaign-portal/namespace/common/id';
import { PaymentSystemName } from '@campaign-portal/namespace/common/enums';
import { PaymentSystem, PaySystemSettings } from '@campaign-portal/namespace/entities/payment-systems/specs';
import { InputComplexType } from '@campaign-portal/namespace/common/entityField';

export interface PaymentSystemEntityConfig<ID = exist | creating> extends Partial<PaymentSystem<ID>> {
	id: ID;
}

const DEFAULT_SETTINGS: PaySystemSettings[] = [
	{
		name: 'fee',
		type: InputComplexType.CHECKBOX,
		value: true,
	},
];

export class PaymentSystemEntity<ID = exist | creating> implements PaymentSystem<ID> {
	id: ID;
	name: string;
	type: PaymentSystemName;
	settings: PaySystemSettings[];
	isActive: boolean;
	partnerId?: Id<exist>;
	host?: string;
	lastUpdated?: string | null;
	creationDate?: string | null;

	constructor(config: PaymentSystemEntityConfig<ID>) {
		this.id = config.id;
		this.name = config.name ?? '';
		this.type = config.type ?? PaymentSystemName.PAYPAL;
		this.settings = config.settings ?? DEFAULT_SETTINGS;
		this.isActive = config.isActive ?? false;
		this.partnerId = config.partnerId;
		this.host = config.host;
		this.lastUpdated = config.lastUpdated;
		this.creationDate = config.creationDate;
	}
}
